import React from 'react'
import { Message } from "../locale/Message";
import logo from "../images/logo-purple.svg";
import { capitalizeText } from '../Utils';

export class ConnectedService extends React.Component {

    redirectToServiceUrl = () => document.location = this.props.service.url

    render() {
        const { lang, service } = this.props;

        return (
            <div className="col-xs-12 col-xl-4 mb-4">
                <div className="card h-100 connected">
                    <div className="card-body bg-white position-relative" onClick={this.redirectToServiceUrl}>
                        <div className="d-flex flex-column">
                            <div className="service-circle text-center">
                                <img src={logo} width="20" />
                            </div>
                            <p className="card-title text-midnight-gray t-bold">
                                {service[`name${capitalizeText(lang)}`]}
                            </p>
                            <div className="card-footer">
                                <ul className="list-unstyled mb-0 d-flex justify-content-between align-items-center">
                                    <li className="d-flex align-items-center text-green font-weight-bold">
                                        <i
                                            className="fa fa-circle mr-2 text-green"
                                            aria-hidden="true"
                                        />
                                        <span
                                            className="t-3 font-weight-bold text-green">{Message.enabled[lang]}
                                        </span>
                                    </li>
                                    <li className="options d-none">
                                        <span>
                                            <i className="d-block fa fa-circle text-midnight-gray" aria-hidden="true" />
                                            <i className="d-block fa fa-circle text-midnight-gray" aria-hidden="true" />
                                            <i className="d-block fa fa-circle text-midnight-gray" aria-hidden="true" />
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}